import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    selector: 'installation-distance',
    templateUrl: './distance.component.html',
    standalone: false
})
export class InstallationDistancePluginComponent {
  public distance: any;
  public config: any;
  public editRoute = ['installation', 'distance', 'edit'];
  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.distance = this.config.Distance;
  }
}
PluginComponent.plugins['installationdistance'] = InstallationDistancePluginComponent;
